/**
 * @param {number} length
 * @return {Array}
 */
var range = function range(length) {
  return Array.apply(null, {
    length: length
  });
};

export default range;


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/utils/range.js